import FrontBusiness from "@/business/FrontBusiness";
import IndicadorAbstractService from "@/business/indicadores/IndicadorAbstractService";
import IndicadorRealHistoricoBusiness from "@/business/indicadores/IndicadorRealHistoricoBusiness";
import IndicadorRealBusiness from "@/business/indicadores/IndicadorRealBusiness";
import RegistroAuxiliarBusiness from "@/business/indicadores/RegistroAuxiliarBusiness";
import IndisponibilidadeBusiness from "@/business/IndisponibilidadeBusiness.js";
import getVar from "@/business/livros/copiladores/getVar.js";
import indicadorPessoal from "@/business/livros/copiladores/indicadorPessoal.js";
import proxy from "@/business/livros/copiladores/proxy.js";
import tabelaSigef from "@/business/livros/copiladores/tabelaSigef.js";
import qualificarEnvolvido from "@/business/livros/utils/qualificarEnvolvido.js";
import PapelBusiness from "@/business/PapelBusiness.js";
import AtoBusiness from "@/business/protocolo/AtoBusiness.js";
import ProtocoloFinanceiroBusiness from "@/business/protocolo/ProtocoloFinanceiroBusiness.js";
import RegraCustasBusiness from "@/business/RegraCustasBusiness.js";
import RegrasEstaduaisBusiness from "@/business/RegrasEstaduaisBusiness.js";
import RegrasEstaduaisRSBusiness from "@/business/RegrasEstaduaisRSBusiness.js";
import SeloBusiness from "@/business/SeloBusiness.js";
import VueBusiness from "@/business/VueBusiness.js";
import Utils from "@/commons/Utils";
import moment from "moment";
import TextParser from './TextParser';
import extenso from '@/commons/extenso';
import tabelaSigefSimplificada from "@/business/livros/copiladores/tabelaSigefSimplificada";
import SigefBusiness from "@/business/SigefBusiness";

export default {

  async gerarMinutaAto(ato, ficha, protocolo, documentos, usuarioLogado = {}){

    let dicionario = await this.gerarDicionario(ato, ficha, protocolo, documentos);
    dicionario.usuarioLogado = { ...usuarioLogado, senha : undefined };

    /** CARREGA ENVOLVIDOS DO ATO **/
    let proprietarios = {};
    (ficha.proprietarios || []).forEach(p => {
      if(p?.indicadorPessoalVersao?.indicadorPessoalId){
        proprietarios[p.indicadorPessoalVersao.indicadorPessoalId] = parseFloat(p.fracao)
      }else{
        console.debug(p)
      }
    });

    let insideEnvolvidoTag = false, ignore = [];
    if(ato){
      await TextParser.tratarEnvolvidos(ato?.envolvidos, dicionario, proprietarios);
    }

    const cache = {};

    const callback = async (nodes = [], dicionario = {}, debug) => {

      let envolvidos = dicionario?.envolvidos?.lista || [];
      if(dicionario.vinculo?.envolvidos?.lista){
        envolvidos = dicionario.vinculo.envolvidos.lista;
      }

      let output = '';

      for(let pos in nodes){
        let node = nodes[pos];

        let debugNode = debug ? { tipo : node.name, nodes : [], params : node.params, custom : {} } : null;

        switch(node.name){

          // case 'taxa':{
          //
          //   if(dicionario.ato){
          //     output += FrontBusiness.formatNumber( dicionario.ato.taxas?.[node.params.tipo] || 0.0 , 2);
          //   }
          //
          //   break;
          // }

          case 'remover':

            //remover do loop caso o conjuge seja apresentado
            if(insideEnvolvidoTag && node.params.conjuge !== undefined){
              if (dicionario.envolvido?.conjuge) {
                ignore.push(dicionario.envolvido.conjuge?.indicadorPessoalId);
              }
            }

            if(insideEnvolvidoTag && node.params.convivente !== undefined){
              if (dicionario.envolvido?.convivente) {
                ignore.push(dicionario.envolvido.convivente?.indicadorPessoalId);
              }
            }

            // Remover dentro de <repetidor> — popula mapa _remover_ para filtrar nas iterações seguintes
            if(dicionario._remover_ && dicionario._chave_){
              let item = dicionario[dicionario._chave_];
              if(item && node.params.conjuge !== undefined){
                let conjugeId = item?.indicadorPessoalVersao?.conjuge?.indicadorPessoalId || item?.conjuge?.indicadorPessoalId;
                if(conjugeId){
                  let fieldPath = item?.indicadorPessoalVersao
                    ? dicionario._chave_ + '.indicadorPessoalVersao.indicadorPessoalId'
                    : dicionario._chave_ + '.indicadorPessoalId';
                  if(!dicionario._remover_[fieldPath]){
                    dicionario._remover_[fieldPath] = [];
                  }
                  dicionario._remover_[fieldPath].push(String(conjugeId));
                }
              }
              if(item && node.params.convivente !== undefined){
                let conviventeId = item?.indicadorPessoalVersao?.conjuge?.indicadorPessoalId || item?.convivente?.indicadorPessoalId;
                if(conviventeId){
                  let fieldPath = item?.indicadorPessoalVersao
                    ? dicionario._chave_ + '.indicadorPessoalVersao.indicadorPessoalId'
                    : dicionario._chave_ + '.indicadorPessoalId';
                  if(!dicionario._remover_[fieldPath]){
                    dicionario._remover_[fieldPath] = [];
                  }
                  dicionario._remover_[fieldPath].push(String(conviventeId));
                }
              }
            }

            break;

          case 'fracao':
            output += this.fracao(node, dicionario, envolvidos );
            break;

          case 'plural':
            output += this.plural(node, dicionario, envolvidos, ato, debugNode);
            break;

          case 'subgrupo':
            //FrontBusiness.showWarn(`Atenção: Utilização do método "subgrupo" na minuta não é mais recomendado. Favor avisar a coordenação.` );
            output += await this.agruparChecklist(dicionario, node, callback, debugNode);
            break;

          case 'checklist':
            //FrontBusiness.showWarn(`Atenção: Utilização do método "checklist" na minuta não é mais recomendado. Favor avisar a coordenação.` );
            output += await this.repetidorChecklist(node, dicionario, callback, debugNode);
            break;

          // Tag antiga: publica a LISTA `documentos` e não abre escopo por documento. Mantida como
          // está — os modelos que a usam esperam <repetidor lista="documentos"> dentro dela.
          case 'documentos':
            const val = dicionario.checklist[node.params.indice];
            let documentos = (Array.isArray(val) ? val : [val]).filter(e => e);
            documentos = documentos.map(i => dicionario.documentos[i]).filter(e => e);
            output += await callback(node.children, {...dicionario, documentos}, debug);
            break;

          case 'documentos-protocolo':
            output += await this.documentosProtocolo(node, dicionario, callback, debugNode);
            break;

          case 'recolhimentos':{
            output += await callback(node.children, dicionario, debug);
            break;
          }

          case 'custas-protocolo':
            if(!dicionario.protocolo.custas && dicionario.protocolo.id){
              dicionario.protocolo.custas = await ProtocoloFinanceiroBusiness.totalConsolidado(dicionario.protocolo.id);
            }
            output += await callback(node.children, dicionario, debug);
            break;

          case 'dajes':
            if(!dicionario.dajes){
              dicionario.dajes = await RegrasEstaduaisBusiness.capturarDajesAtoBA(ato.id);
            }
            output += await callback(node.children, dicionario, debug);
            break;

          /*******************************************************************************************/
          case 'condicao':{

            // VALIDAÇÃO DA QUANTIDADE DE RESTRIÇÕES
            if(node.params.se == 'restricoes.imovel'){
              if(!cache.restricoes){
                cache.restricoes = await IndicadorRealBusiness.restricoesVigentes(ficha.id);
              }

              let tipos = false;
              if(node.params.tipo !== undefined){
                tipos = node.params.tipo.split('|');
              }

              dicionario.restricoes = {...(dicionario.restricoes || {}), imovel : cache.restricoes.filter(e => !tipos || tipos.includes(e.restricao)).length }
            }

            output += await TextParser.commonsParse(node, dicionario, callback, debugNode);
            break;

          }

          case 'restricoes-canceladas' : {
            let ids = ato?.dto?.restricoesCanceladas || [];

            let restricoesCanceladas = await AtoBusiness.getRestricoesPorId(ato.id, ids);

            restricoesCanceladas = (restricoesCanceladas || []).map(restricao => {

              let ato = JSON.parse(restricao.descricaoRestricao);

              let codigo = ato.codigo || ato.codigoAto;
              if(!codigo){
                codigo = AtoBusiness.getCodigo(ato, ficha, ato.tipoAto, true);
              }
              return {
                ato: {
                  codigo: codigo,
                  tipo: ato.tipoAto == 'REGISTRO' ? 'R' : 'Av',
                  titulo: ato.opcoes.titulo,
                },
                pessoa: {
                  nome : restricao.nome,
                  documento : restricao.documento,
                  restricao : restricao.restricao,
                  papel : restricao.papel,
                },
              }
            });

            if(ato?.dto?.restricoesCanceladasSemRegistrar?.length){

              let method = ato.livro != 'REGISTRO_AUXILIAR' ? AtoBusiness.restricoesSemRegistrar : AtoBusiness.restricoesSemRegistrarRegistroAuxiliar;

              let restricoes = (await method(protocolo?.id, ato?.id, ficha?.id));

              const restricoesCanceladasSemRegistrar = this.ato.dto.restricoesCanceladasSemRegistrar;
              restricoes = (restricoes || []).filter(restricao => {
                return restricoesCanceladasSemRegistrar.filter(r => r.atoId === restricao.atoId
                  && r.restricao === restricao.restricao && r.indicadorPessoalVersaoId === restricao.indicadorPessoalVersaoId ).length > 0
              }).map(restricao => {

                let a = JSON.parse(restricao.descricaoRestricao);

                const codigo = AtoBusiness.gerarCodigoSimplificado(a?.ordem, ficha?.ctrl?.ultimoAto || 0, a?.tipoAto, ficha?.ctrl?.status);

                return {
                  ato: {
                    codigo: codigo,
                    tipo: a?.tipoAto == 'REGISTRO' ? 'R' : 'Av',
                    // titulo: ato.opcoes.titulo,
                    // checklist: ato.checklist,
                  },
                  pessoa: {
                    // nome : restricao.nome,
                    // documento : restricao.documento,
                    // restricao : restricao.restricao,
                    // papel : restricao.papel,
                  },
                }

              });

              restricoesCanceladas.push(...(restricoes || []));

            }

            output += await callback(node.children, {...dicionario, restricoesCanceladas}, debugNode);
            break;
          }

          case 'qualificacao': {

            let papel = node.params.papel, inserirConjugue = node.params.conjuge || true, outputEnvolvidos = [], pular = [];

            for(let eI in envolvidos){
              let envolvido = envolvidos[eI];

              if (!papel || envolvido.papel == papel) {

                if (pular.includes(envolvido.indicadorPessoalVersao.indicadorPessoalId)) {
                  continue;
                }

                if (envolvido.indicadorPessoalVersao.conjuge) {
                  let conjuge = envolvidos.find(e => e.indicadorPessoalVersao?.indicadorPessoalId == envolvido?.indicadorPessoalVersao.conjuge?.indicadorPessoalId);

                  if (conjuge) {
                    envolvido.conjuge = {...conjuge};
                    envolvido.indicadorPessoalVersao.conjuge = {...conjuge.indicadorPessoalVersao};
                    envolvido.conjugeId = conjuge.indicadorPessoalVersao.indicadorPessoalId;
                    if(inserirConjugue){
                      pular.push(envolvido.conjugeId);
                    }
                  }

                }

                outputEnvolvidos.push(await qualificarEnvolvido(envolvido.indicadorPessoalVersao, null, true, inserirConjugue));

              }
            }

            output += FrontBusiness.formatArray(outputEnvolvidos, node.params.separador || ', ', node.params.ultimo || ' e ');

            break;
          }

          case 'envolvidos-vinculo':
          case 'envolvidos' : {

            insideEnvolvidoTag = true, ignore = [];
            let papel = node.params.papel, outputEnvolvidos = [], lista = node.params.lista !== undefined, listagem = [];

            let i = 0;

            for(let eI in envolvidos){
              let envolvido = envolvidos[eI];

              if (!papel || envolvido.papel == papel) {

                if (ignore.includes(envolvido.indicadorPessoalVersao.indicadorPessoalId)) {
                  continue;
                }

                if (envolvido.indicadorPessoalVersao.conjuge) {
                  let conjuge = envolvidos.find(e => e.indicadorPessoalVersao?.indicadorPessoalId == envolvido?.indicadorPessoalVersao.conjuge?.indicadorPessoalId);

                  if (conjuge) {
                    envolvido.conjuge = {...conjuge};
                    envolvido.indicadorPessoalVersao.conjuge = {...conjuge.indicadorPessoalVersao};
                    envolvido.conjugeId = conjuge.indicadorPessoalVersao.indicadorPessoalId;
                  }

                }
                let envolvidoDicionario = await this.gerarDicionarioEnvolvido(envolvido, proprietarios, dicionario.checklist.envolvidos);
                envolvidoDicionario.posicao = ++i;

                if(lista){
                  listagem.push(envolvidoDicionario);
                }else{
                  dicionario.envolvido = envolvidoDicionario;
                  outputEnvolvidos.push(await callback(node.children, dicionario, debugNode));
                  dicionario.envolvido = null;
                }

              }
            }

            if(lista){
              output += await callback(node.children, {...dicionario, envolvidos: listagem}, debugNode);
            }else{
              output += FrontBusiness.formatArray(outputEnvolvidos, node.params.separador, node.params.ultimo);
            }
            insideEnvolvidoTag = false;
            break;

          }

          case 'registros-posteriores': {
            if (!cache.registrosPosteriores) {
              cache.registrosPosteriores = await IndicadorAbstractService.getTagRegistrosPosteriores(ficha.id) || [];
            }
            output += await callback(node.children, {...dicionario, registrosPosteriores: cache.registrosPosteriores}, debugNode);
            break;
          }

          case 'registros-posteriores-numeracao': {
            output += '';
            break;
          }

          case 'dados-anteriores': {
            if (!cache.dadosAnteriores) {
              cache.dadosAnteriores = await IndicadorRealHistoricoBusiness.getTagDadosAnteriores(ficha.id) || [];
            }
            output += await callback(node.children, {...dicionario, dadosAnteriores: cache.dadosAnteriores}, debugNode);
            break;
          }

          case 'tabela-sigef': {
            output += await tabelaSigef(ficha, node, callback, dicionario, debugNode);
            break;
          }

          case 'tabela-sigef-simplificada': {
            output += await tabelaSigefSimplificada(ficha, node, callback, dicionario, debugNode);
            break;
          }

          /*******************************************************************************************/

          default:
            output += await TextParser.commonsParse(node, dicionario, callback, debugNode);
            break;
        }

        if(debugNode){
          debugNode.conteudo = TextParser.htmlText(node.body);
          if(debugNode.tipo || debugNode.conteudo){
            debug?.nodes.push({...debugNode});
          }
        }

      }

      return output;
    };

    await TextParser.init();
    let template = ato.templateMinuta || ato.tipoServico.minuta;
    if (!template) return null;
    let texto = await TextParser.parse(template, callback, dicionario);

    return TextParser.clean(texto + '.');

  },

  /**
   * Os documentos do protocolo indexados por id, como o dicionário de minuta os enxerga.
   *
   * Espelha `ProtocoloDocumentoVariaveis.mapear` do backend — é o mesmo conjunto de chaves, para
   * que um modelo com <documentos-protocolo> renda o mesmo texto sendo compilado aqui (minuta do
   * ato, exigência) ou lá (impressão de exigência, certidão, recibo).
   *
   * Entra em `dicionario.documentos`, que é MAPA e não lista: o filtro por índice de checklist
   * resolve id → documento, e `repetidorChecklist` depende disso.
   */
  mapearDocumentos(documentos = []){
    const docs = {};
    documentos.forEach(d => {
      // `campos` são os campos padrão da espécie, que vêm de ProtocoloDocumentoVariaveis no
      // backend. Vêm depois dos índices de propósito: se um índice de checklist tiver o mesmo nome
      // de um campo padrão, a coluna é que vale — ela é a fonte com tipo e a que a tela edita.
      docs[d.id] = {
        ...d.indices,
        ...(d.campos || {}),
        id : d.id,
        nome : d.nome,
        tituloDocumento : d.nome,
        tipoDocumento : d.tipo,
        tipoDocumentoId : d.tipoId,
        especie : d.especieNome,
        especieId : d.especie,
      };
    });
    return docs;
  },

  async gerarDicionario(ato, ficha, protocolo = {}, documentos = [], simplificado = false){
    let docs = this.mapearDocumentos(documentos);

    const dicionario = {
      protocolo : {},
      imovel : {},
      registro : {},
      checklist : {},
      documentos : docs,
    };

    /**
     * CONFIGURACOES DO PROTOCOLO
     */
    if (protocolo?.id != null) {

      dicionario.protocolo = {
        id : protocolo.id,
        codigo : protocolo.codigo,
        dataCadastro : protocolo.cadastro,
        dataReingresso : protocolo.reingresso,
        dataRegistro : protocolo.registro ? protocolo.registro : moment(),
        tipo : protocolo.tipoProtocolo,
        tipoRegistro : protocolo.tipoRegistro,
        registrado: !!protocolo.registro,
        protocoloExterno: protocolo.protocoloExterno,
        identificacaoEstadual: protocolo.identificacaoEstadual,
        dadosImportados: protocolo.dadosImportados,
        livro:protocolo.livro,
        folha:protocolo.folha,
        dataBaseCalculo: protocolo.dataBase,
        senha : protocolo.senha,
        codigoesenha : 'Código: ' + (protocolo.codigo || '') + ' | Senha: ' + (protocolo.senha || '')
      };

      if (protocolo.interessado) {
        const docDigitsI = (protocolo.interessado.documento || '').replace(/\D/g, '');
        dicionario.protocolo.interessado = {
          nome: protocolo.interessado.nome,
          documento: protocolo.interessado.documento,
          cpf: docDigitsI.length === 11 ? protocolo.interessado.documento : null,
          cnpj: docDigitsI.length === 14 ? protocolo.interessado.documento : null,
        };
      }

      if (protocolo.solicitante) {
        const docDigitsS = (protocolo.solicitante.documento || '').replace(/\D/g, '');
        dicionario.protocolo.solicitante = {
          nome: protocolo.solicitante.nome,
          documento: protocolo.solicitante.documento,
          cpf: docDigitsS.length === 11 ? protocolo.solicitante.documento : null,
          cnpj: docDigitsS.length === 14 ? protocolo.solicitante.documento : null,
        };
      }

      if (protocolo.natureza) {
        dicionario.protocolo.natureza = { nome: protocolo.natureza.nome };
      }

      if (protocolo.tipoServico) {
        dicionario.protocolo.tipoServico = { nome: protocolo.tipoServico.nome };
      }

      if (protocolo.dadosImportados?.autorizacoes) {
        const autorizacoes = protocolo.dadosImportados.autorizacoes;
        const declaroRaw = autorizacoes.DECLARO;
        const listaDeclaro = (Array.isArray(declaroRaw) ? declaroRaw : [declaroRaw]).filter(Boolean);
        const textoDeclaro = listaDeclaro.join('\n');
        const autorizo = autorizacoes.AUTORIZO || [];
        dicionario.protocolo.dadosImportados.autorizacoesDeclaro = textoDeclaro;
        listaDeclaro.forEach((item, index) => {
          dicionario.protocolo.dadosImportados[`autorizacoesDeclaracao${index + 1}`] = item;
        });
        const listaAutorizo = (Array.isArray(autorizo) ? autorizo : [autorizo]).filter(Boolean);
        dicionario.protocolo.dadosImportados.autorizacoesAutorizo = listaAutorizo;
        listaAutorizo.forEach((item, index) => {
          dicionario.protocolo.dadosImportados[`autorizacoesAutorizacao${index + 1}`] = item;
        });
        let textoAutorizacoes = textoDeclaro;
        for (const item of listaAutorizo) {
          if (textoAutorizacoes) textoAutorizacoes += '\n';
          textoAutorizacoes += item;
        }
        dicionario.protocolo.dadosImportados.autorizacoesTexto = textoAutorizacoes;
      }

      if(protocolo?.tabelionato?.id){
        dicionario.protocolo.tabelionato = {
          estado: protocolo?.tabelionato.estado,
          telefone: protocolo?.tabelionato.telefone,
          emails: protocolo?.tabelionato.emails,
          nome: protocolo?.tabelionato.nome
        }
      }

      if(!simplificado){
        dicionario.protocolo.seloPrincipal = protocolo?.seloPrincipal || await SeloBusiness.getSeloProtocolo(protocolo.id);
        dicionario.protocolo.selo = dicionario.protocolo?.seloPrincipal?.codigo;
      }

      /**
       * CONFIGURACOES DA INDISPONIBILIDADE
       */
      if(protocolo?.indisponibilidade?.id && !simplificado){

        let indisponibilidade = protocolo?.indisponibilidade;
        if(!protocolo?.indisponibilidade?.protocoloCnib){
          indisponibilidade = await IndisponibilidadeBusiness.getResumoById(protocolo.indisponibilidade?.id);
        }

        //protocolo, data do protocolo da cnib, numero do processo, campo juizo
        dicionario.protocolo.indisponibilidade = {
          data : (indisponibilidade.pedido || ''),
          pedido : (indisponibilidade.pedido || ''),
          cancelamento : (indisponibilidade.cancelamento || ''),
          protocoloCnib : indisponibilidade.protocoloCnib,
          protocoloCnibCancelado : indisponibilidade.protocoloCnibCancelado,
          numeroProcesso : indisponibilidade.numeroProcesso,
          instituicao : indisponibilidade.instituicao,
          forumVara : indisponibilidade.forumVara,
          juizo : indisponibilidade.juizo,
          solicitante : indisponibilidade.solicitante
        }
      }
      //dicionario['protocolo.codigo'] = MinutaParser.formatarCodigo(protocolo.codigo);
    }

    if(ato?.id){

      /**
       * CONFIGURACOES DO ATO
       */

      const codigos = Object.values(ato.custas).map(value => {
        return `${value.codigoTj} (${value.quantidade || 1})`;
      });
      const codigosTjFormatados = `Cod. Ato(s): ${codigos.join(", ")}`;
      const codigosAto = Object.values(ato.custas).filter(v => v.codigoAtoCusta).map(value => {
        return `${value.codigoAtoCusta} (${value.quantidade || 1})`;
      });
      const codigosAtoFormatados = codigosAto.join(", ");
      dicionario.ato = {
        registrado: !!protocolo.registro,
        id : ato.id,
        dataBaseCobranca: ato.dataBase,
        codigo : (ato.codigo || ato.codigoAto || '{{ATO}}') + '', //AtoBusiness.getCodigo(ato, ficha)))
        tipo : (ato.tipoServico.opcoes.tipoAto == 'AVERBACAO' ? 'Av' : 'R'),
        tipoRegistro: ato.tipoRegistro,
        selo: '<span class="text-info-soft">{{SELOS}}</span>',
        selos: '<span class="text-info-soft">{{SELOS}}</span>',
        seloLetras: '<span class="text-info-soft">{{SELO_LETRAS}}</span>',
        seloNumeros: '<span class="text-info-soft">{{SELO_NUMEROS}}</span>',
        seloAleatorio: '<span class="text-info-soft">{{SELO_ALEATORIO}}</span>',
        seloCompleto: '<span class="text-info-soft">{{SELO_COMPLETO}}</span>',
        isento : ato.isento,
        tipoIsencao : ({'RESSARCIVEL': 'Ressarcível', 'NAO_RESSARCIVEL': 'Não ressarcível'})[ato.ressarcimento?.tipoIsencao] || null,
        motivoIsencao : FrontBusiness.getLabel(ato.ressarcimento?.motivoIsencao, RegraCustasBusiness.getMotivosIsencao(window.server.config?.estado)) || null,
        codigoIsencao : ato.ressarcimento?.motivoIsencao?.split('_')?.[1] || null,
        valor : ato.valor,
        guia : ato.guia,
        codigoFiscal : ato.codigoFiscal,
        codigoAto : ato.custas && Object.values(ato.custas).length > 0 ? Object.values(ato.custas)[0].codigoAtoCusta : null,
        codigoAtoEmolumento : ato.custas && Object.values(ato.custas).length > 0 ? Object.values(ato.custas)[0].codigoAtoCusta : null,

        diferido : ato.diferido || false,
        motivoDiferimento : ato.motivoDiferimento,

        titulo : ato.tipoServico.opcoes.titulo,
        nomenclatura : ato.tipoServico.nome,
        numeroCat : ato.numeroCat,

        numeroControleLivro: ato.numeroControleLivro,
        numeroControleLivroFinal: ato.numeroControleLivroFinal,
        numeroControleFolha: ato.numeroControleFolha,
        quantidadeFolhas: ato.quantidadeFolhas,
        numeroUltimaFolha: ato.numeroControleLivro && ato.numeroControleFolha ? ato.numeroControleFolhaFinal || (ato.numeroControleFolha + ato.quantidadeFolhas - 1) : null,
        codigosTjFormatados: codigosTjFormatados,
        codigosAtoFormatados: codigosAtoFormatados,
        doi : {},
        valores : {},

        ficha : {...ficha, usuarioImpressao : undefined, usuarioEncerramento: undefined},
        dto : ato.dto,
        moeda : {
          alienacao : ato.dto?.camposAdicionais?.MOEDA_ALIENACAO,
          avaliacao : ato.dto?.camposAdicionais?.MOEDA_AVALIACAO,
          divida : ato.dto?.camposAdicionais?.MOEDA_DIVIDA,
        },
      };

      // Variáveis específicas de arquivamento
      const custasValues = ato.custas ? Object.values(ato.custas) : [];
      const custaArquivamento = custasValues.find(c =>
        (c.descricao && c.descricao.includes('Arquivamento')) ||
        (c.codigoTj && String(c.codigoTj).replace(/\D/g, '') === '8101')
      );
      if (custaArquivamento) {
        dicionario.ato.arquivamento = {
          quantidade: custaArquivamento.quantidade != null ? parseInt(custaArquivamento.quantidade) : 0,
          emolumentos: custaArquivamento.emolumentos || 0,
          emolumentosBrutos: custaArquivamento.emolumentosOriginal || 0,
          taxaJudiciaria: custaArquivamento.taxaJudiciaria || 0,
          iss: custaArquivamento.iss || 0,
          ibs: custaArquivamento.ibs || 0,
          cbs: custaArquivamento.cbs || 0,
          fundosEstaduais: custaArquivamento.fundosEstaduais || 0,
          total: custaArquivamento.total || 0,
        };
      } else {
        dicionario.ato.arquivamento = {
          quantidade: 0,
          emolumentos: 0,
          emolumentosBrutos: 0,
          taxaJudiciaria: 0,
          iss: 0,
          ibs: 0,
          cbs: 0,
          fundosEstaduais: 0,
          total: 0,
        };
      }

      dicionario.ato.livros = await AtoBusiness.getSimularControleFolhas(ato.id);

      let quantidadePaginasAnexos = 0;
      if (documentos && documentos.length > 0) {
        documentos.forEach(d => {
          if (d.totalPagina) {
            quantidadePaginasAnexos += d.totalPagina;
          } else if (d.tipo && d.tipo.startsWith('image/')) {
            quantidadePaginasAnexos += 1;
          }
        });
      }
      dicionario.ato.quantidadePaginasAnexos = quantidadePaginasAnexos;

      if (window.server.config.livros.livroRegistroIntegral.rtdpjFrenteVerso) {
        dicionario.ato.numeroControleFolha += (ato.ladoPaginaControleInicial || '');
        if (ato.numeroControleFolhaFinal) {
          dicionario.ato.numeroUltimaFolha = (ato.numeroControleFolhaFinal || '') + (ato.ladoPaginaControleFinal || '');
        } else {
          dicionario.ato.numeroUltimaFolha = ato.numeroControleLivro && ato.numeroControleFolha ? ato.numeroControleFolha + (ato.quantidadeFolhas / 2) - 1 : null;
        }
      }

      dicionario.ato.dto.camposAdicionais.TIPO_REGISTRO = ato.tipoRegistro;

      if(!protocolo.registro){
        dicionario.ato.codigo = '{{ATO}}';
      }

      if(dicionario.ato.ficha.status == 'PENDENTE'){
        dicionario.ato.ficha.codigo = '<span class="text-info-soft">{{MATRICULA}}</span>'
      }else{
        dicionario.ato.ficha.codigo = dicionario.ato.ficha.codigo
      }

      if (ato.doi.gerarDoi) {
        dicionario.ato.doi = {
          situacaoDaConstrucao : FrontBusiness.getLabel(ato.doi.situacaoConstrucao, IndicadorRealBusiness.getSituacoesDoi()).toLowerCase(),
          formaDeAlienacaoAquisicao : FrontBusiness.getLabel(ato.doi.formaAlienacao, IndicadorRealBusiness.getFormasDoi()).toLowerCase(),
          dataDaAlienacao : ato.doi.dataAlienacao,
        };
      }

      if (ato.dto.valoresBaseCalculo) {
        Object.keys(ato.dto.valoresBaseCalculo).forEach(k => dicionario.ato[k] = ato.dto.valoresBaseCalculo[k]);
        dicionario.ato.valorAlienacao = ato.dto.valoresBaseCalculo.alienacao;
        dicionario.ato.valorAlienacaoAtualizado = ato.dto.valoresBaseCalculo.alienacaoAtualizado;
      }

      dicionario.ato.baseCalculo = {
        valor: ato.baseCalculoMinuta?.valor ?? null,
        titulo: ato.baseCalculoMinuta?.titulo ?? null,
      };

      if (ato.ressarcimento) {
        const tipoIsencaoLabels = {'RESSARCIVEL': 'Ressarcível', 'NAO_RESSARCIVEL': 'Não ressarcível'};
        dicionario.ato.ressarcimento = {
          tipoIsencao: tipoIsencaoLabels[ato.ressarcimento?.tipoIsencao] || null,
          motivoIsencao: ato.ressarcimento?.motivoIsencao || null,
          motivoIsencaoDescricao: FrontBusiness.getLabel(ato.ressarcimento?.motivoIsencao, RegraCustasBusiness.getMotivosIsencao(window.server.config?.estado)) || null,
          motivoIsencaoId: ato.ressarcimento?.motivoIsencao?.split('_')?.[1],
          tipoProcesso: FrontBusiness.getLabel(ato.ressarcimento?.tipoProcesso, RegraCustasBusiness.getTiposProcessoRessarcimento(window.server.config?.estado))?.toLowerCase(),
          tipoProcessoId: ato.ressarcimento?.tipoProcesso?.split('_')?.[1],
          numeroProcesso: ato.ressarcimento?.numeroProcesso,
          tipoIsencaoProcessamentoEletronico: tipoIsencaoLabels[ato.ressarcimento?.tipoIsencaoProcessamentoEletronico] || null,
          motivoIsencaoProcessamentoEletronico: ato.ressarcimento?.motivoIsencaoProcessamentoEletronico || null,
          motivoIsencaoProcessamentoEletronicoDescricao: FrontBusiness.getLabel(ato.ressarcimento?.motivoIsencaoProcessamentoEletronico, RegraCustasBusiness.getMotivosIsencao(window.server.config?.estado)) || null,
        codigoIsencaoProcessamentoEletronico: ato.ressarcimento?.motivoIsencaoProcessamentoEletronico?.split('_')?.[1] || null,
        codigoIsencaoBusca: ato.ressarcimento?.motivoIsencaoBusca?.split('_')?.[1] || null,
      }
      }

      dicionario.ato.frj = [];
      if(ato.recolhimentos){
        if(typeof ato.recolhimentos === 'string'){
          ato.recolhimentos = JSON.parse(ato.recolhimentos || '[]');
        }
        dicionario.ato.recolhimentos = ato?.recolhimentos || [];
        ato?.recolhimentos?.forEach(r => {
          if(r.tipo == 'FRJ'){
            dicionario.ato.frj.push(r);
          }
        });
      }

      // GERA AS TAXAS DO PROTOCOLO:
      let custas = ato.custas;
      if(ato.dto?.camposAdicionais?.ABATER_PRENOTACAO && VueBusiness.getVueRoot().isEstadoRO) {
        // capturar a custa de abatimento;
        const abatimentos = await RegrasEstaduaisBusiness.getCustaAbatimentoRO(protocolo.id).catch(e => ([]));
        if (abatimentos?.length) {
          custas = [...Object.values(custas), ...Object.values(abatimentos?.[0]?.custas)];
        }
      }

      if(VueBusiness.getVueRoot().isEstadoRS) {
        dicionario.ato.custasIndividuais = {};
        dicionario.ato.custasIndividuais['REGRA'] = [];
        dicionario.ato.custasIndividuais['ADICIONAL'] = [];

        for (const key in ato.custas) {
          let item = ato.custas[key];
          const tabela = item.tabela;

          item = {
            'emolumentos': item.emolumentos,
            'valorSelo': item.custoSelo,
          }

          if (tabela == ato.tipoServico.regraCusta) {
            dicionario.ato.custasIndividuais['REGRA'].push(item);
          } else if (tabela === ato.tipoServico.regraCusta + '_ADICIONAL') {
            dicionario.ato.custasIndividuais['ADICIONAL'].push(item);
          } else {
            dicionario.ato.custasIndividuais[tabela] = item;
          }
        }
      }

      const obj = FrontBusiness.somarTaxas(custas);
      obj.totalSemIss = obj.iss > 0 && obj.total > 0 ? FrontBusiness.twoDecimals((obj.total || 0) - obj.iss) : obj.total;
      Object.values(ato.custas || {}).forEach(custa => {
        obj.vrc = obj.vrc || custa.vrc;
      });

      dicionario.prenotacao = ato.prenotacao;
      dicionario.busca = ato.busca;
      dicionario.totalizador = FrontBusiness.somarTaxas({
        ato: obj || {},
        prenotacao: ato.prenotacao || {},
        busca: ato.busca || {},
      })

      dicionario.ato = {...dicionario.ato, ...obj};
      dicionario.ato.emolumentosUnificados = obj.emolumentos;
      dicionario.ato.selosUnificados = obj.custoSelo;

      const posteriorZerado = {resumo: {emolumentos: 0, iss: 0, custoSelo: 0, total: 0}};
      const valoresPosterior = VueBusiness.getVueRoot().isEstadoRS ? await RegrasEstaduaisRSBusiness.getValoresPosteriorAto(ato.id).catch(e => posteriorZerado) : posteriorZerado;

      dicionario.ato.emolumentosPosterior = valoresPosterior?.resumo?.emolumentos || 0;
      dicionario.ato.issPosterior = valoresPosterior?.resumo?.iss || 0;
      dicionario.ato.custoseloPosterior = valoresPosterior?.resumo?.custoSelo || 0;
      dicionario.ato.totalPosterior = valoresPosterior?.resumo?.total || 0;
      dicionario.ato.processamentoEletronicoPosterior = valoresPosterior?.processamentoEletronico || null;
      dicionario.ato.buscasPosterior = valoresPosterior?.buscas || null;
      dicionario.ato.digitalizacaoPosterior = valoresPosterior?.digitalizacao || null;
      dicionario.ato.principalPosterior = valoresPosterior?.principal || null;

      if (ato.vrcCalculado != null) {
        dicionario.ato.vrcCalculado = ato.vrcCalculado;
      }

      //livro estrangeiro
      if(AtoBusiness.mostrarCampoLivroEstrangeiro(ato)){
        dicionario.ato.livroEstrangeiro = {
          codigo: '{{LIVRO_ESTRANGEIRO}}',
          observacao : ato.observacaoLivroEstrangeiro
        }
      }

    }

    /**
     * Imovel
     */
    if (ficha?.id && ficha.tipoImovel) {

      dicionario.imovel = await this.gerarDicionarioImovel(ficha, simplificado);
      dicionario.imovel.novo = {};

      if(ato?.id){
        dicionario.ato.ficha.codigo = dicionario.imovel.codigo;
        Object.keys(ato.dto.indicador || {}).forEach(campo => {
          dicionario.imovel.novo[campo] = ato.dto?.indicador?.[campo];
        });
        dicionario.imovel.novo.codigoSncrFormatado = Utils.formatters.codigoSncr(dicionario.imovel.novo.codigoSncr);
        if (Array.isArray(dicionario.imovel.novo.finalidadesUso)) {
          const lista = IndicadorRealBusiness.getFinalidadesUso();
          dicionario.imovel.novo.finalidadesUso = dicionario.imovel.novo.finalidadesUso
            .map(id => lista.find(e => e.id == id)?.nome || id)
            .join(', ') || null;
        }
      }

    }

    /**
     * registro auxiliar
     */
    if (ficha?.id && (ficha.tipoRegistro || ficha.livro == 'REGISTRO_AUXILIAR' )) {

      dicionario.registro = await this.gerarDicionarioRegistroAuxiliar(ficha, simplificado);

      if(ato?.id){
        dicionario.ato.ficha.codigo = dicionario.registro.codigo;

        dicionario.registro.novo = {
          tipoCedula : ato.dto.tipoCedula,
          condominio : ato.dto.condominio,
          pacto : ato.dto.pacto,
          vencimentoCedula : ato.dto.vencimento,
          valorCedula : ato.dto.valoresBaseCalculo && ato.dto.valoresBaseCalculo.valorRegistro ? ato.dto.valoresBaseCalculo.valorRegistro: null,
          texto : ato.dto.texto,
          garantia : ato.dto.texto
        };

        if(dicionario.registro.novo.tipoCedula){
          dicionario.registro.novo.tipoCedula = FrontBusiness.getLabel(dicionario.registro.novo.tipoCedula, RegistroAuxiliarBusiness.getTiposCedulas()).toLowerCase();
        }

      }

      dicionario.registroAuxiliar = dicionario.registro;

    }

    dicionario.checklist = Utils.merge({}, dicionario?.checklist || {}, protocolo?.indices || {}, ato?.indices || {});

    return dicionario;

  },

  async gerarDicionarioImovel(ficha, simplificado= false){

    let imovel = {...ficha, usuarioImpressao : undefined, usuarioEncerramento: undefined};
    imovel.categoria = FrontBusiness.getLabel(ficha.categoria, IndicadorRealBusiness.getCategorias()).toLowerCase();
    imovel.tipoImovel = FrontBusiness.getLabel(ficha.tipoImovel, IndicadorRealBusiness.getTiposImovel()).toLowerCase();

    if(imovel.status == 'PENDENTE' || imovel.prematricula){
      imovel.codigo = FrontBusiness.formatarCodigoPreMatricula(imovel.codigo, {status : 'PENDENTE', id : imovel.id})
    }

    if(imovel.origens?.length){
      for(let origem of imovel.origens){
        if(origem.tipo == 'PRE_MATRICULA'){
          origem.codigo = FrontBusiness.formatarCodigoPreMatricula(origem.codigo||origem.registro, {
            status : 'PENDENTE',
            id : origem.origemId,
            codigo: origem.codigo||origem.registro,
            livro: 'MATRICULA'
          })
        }
      }
    }

    imovel.tipoImovelDescricao = imovel.descricaoTipoImovelOutros;
    imovel.areaTotal = imovel?.areas?.reduce((acc, cur) => acc + cur.area, 0.00);
    imovel.areaEdificadaTotal = imovel?.areasEdificadas?.reduce((acc, cur) => acc + cur.area, 0.00);
    const areasPrivativas = imovel?.areas?.filter(a => a?.tipo?.toUpperCase() === 'PRIVATIVA') || [];
    if (areasPrivativas.length) {
      imovel.areaPrivativaTotal = areasPrivativas.reduce((acc, cur) => acc + cur.area, 0.00);
    }
    const height = 100, width = 100;
    const urlQr = imovel.georreferenciamentoQr;
    imovel.georreferenciamentoQr = `<img class="qrcode" src="${window.server.API}/api/public/qrcode/${width}/${height}/?text=${encodeURIComponent(urlQr)}&size=250x250" alt="QR Code">`;
    if(imovel.categoria !== undefined && imovel.categoria !== null && imovel.categoria.trim() !== "") {
      let tiposSigef = await SigefBusiness.listarTipoSig(imovel.categoria.toUpperCase());
      imovel.tipoSig = tiposSigef.find(t => t.id === imovel.tipoSig)?.nome || null;
    }

    if(ficha?.proprietarios?.length && !simplificado){

      let envolvidos = [], proprietarios = {};
      for(let eI in ficha.proprietarios){
        let pessoa = await this.gerarDicionarioEnvolvido({...ficha.proprietarios[eI]}, proprietarios);
        pessoa.indicadorPessoalVersao = {...ficha.proprietarios[eI].indicadorPessoalVersao};
        envolvidos.push(pessoa);
      }
      imovel.proprietarios = envolvidos;

    }

    imovel.projetoAprovadoLoteamento = ficha.projetoAprovadoLoteamento;
    imovel.subBairro = ficha.subBairro;
    imovel.codigoLogradouro = ficha.codigoLogradouro;

    if (imovel.confrontacoes && imovel.confrontacoes.length) {
      imovel.confrontacoes.forEach(item => {
        if (!item.tipoVinculo) {
          item.tipoVinculo = 'MATRICULA';
        }
        if (item.tipoVinculo === 'INDICADOR_REAL_EXTERNO') {
          item.matricula = null;
        } else {
          item.indicadorRealExterno = null;
        }
      });
      imovel.confrontacoesMatricula = imovel.confrontacoes.filter(c => c.tipoVinculo === 'MATRICULA');
      imovel.confrontacoesIndicadorRealExterno = imovel.confrontacoes.filter(c => c.tipoVinculo === 'INDICADOR_REAL_EXTERNO');
    }

    imovel.codigoSncrFormatado = Utils.formatters.codigoSncr(imovel.codigoSncr);

    if (Array.isArray(imovel.finalidadesUso)) {
      const lista = IndicadorRealBusiness.getFinalidadesUso();
      imovel.finalidadesUso = imovel.finalidadesUso
        .map(id => lista.find(e => e.id == id)?.nome || id)
        .join(', ') || null;
    }

    return imovel;
  },

  async gerarDicionarioRegistroAuxiliar(ficha, simplificado = false){

    let registro = {...ficha, usuarioImpressao : undefined, usuarioEncerramento: undefined};

    if(registro.categoria){
      registro.categoria = FrontBusiness.getLabel(registro.categoria, RegistroAuxiliarBusiness.getTipos()).toLowerCase();
    }

    if(registro.tipoCedula){
      registro.tipoCedula = FrontBusiness.getLabel(registro.tipoCedula, RegistroAuxiliarBusiness.getTiposCedulas()).toLowerCase();
    }

    if(registro.status == 'PENDENTE' || registro.prematricula){
      registro.codigo = '<span class="text-info-soft">{{MATRICULA}}</span>'
      registro.cnm = '<span class="text-info-soft">{{CNM}}</span>'
    }

    return registro;
  },

  async gerarDicionarioEnvolvido(envolvido, proprietarios, indices = {}){

    const dicionarioEnvolvido = async function(versao = {}, envolvido = {}, proprietarios = {}, indices = {}){
      envolvido.representantes = envolvido?.representantes || [];
      let docRepresentantes = envolvido?.representantes?.map(re => re.documento || ' Documento não informado');
      let procuradorPrincipal = envolvido?.representantes?.find(re => re.principal) ?? envolvido?.representantes?.[0];
      let dados = await indicadorPessoal.tratarDicionarioPessoa(versao);
      let dicionario = {
        ...dados,
        consultaCNIB : envolvido.consultaCnib,
        dataConsultaCnib : envolvido.dataConsultaCnib ? new Date(envolvido.dataConsultaCnib).toLocaleDateString('pt-BR') : '',
        horaConsultaCnib : envolvido.dataConsultaCnib ? new Date(envolvido.dataConsultaCnib).toLocaleTimeString('pt-BR') : '',
        resultadoConsultaCnib : envolvido.resultadoConsultaCnib ? envolvido.resultadoConsultaCnib.toLowerCase() : '',
        papel : envolvido.papel,
        papelNome : PapelBusiness.getNomePapel(envolvido.papel),
        fracao : envolvido.fracao,
        procurador: procuradorPrincipal?.documento,
        procuradorId: procuradorPrincipal?.indicadorPessoalVersaoId,
        inventariante: envolvido.inventariante,
        inventarianteId:envolvido.inventarianteId,
        areaInformada: envolvido.area,
        medidaAreaInformada: envolvido.medidaArea,
        representantes: docRepresentantes.length >0? docRepresentantes.join(',') : "",
        dataAssinatura: envolvido.dataAssinatura,
        tipoAssinatura: envolvido.tipoAssinatura,
        dedoAssinatura: envolvido.dedoAssinatura,
        conjuge : null
      };

      let id = versao?.indicadorPessoalId || versao?.indicadorPessoalVersao?.indicadorPessoalId;

      dicionario.proprietario = !!proprietarios[id];

      // verificar se transmissao é total
      if(envolvido.papel == 'TRANSMITENTE' && envolvido.fracao > 0 && proprietarios[id]){
        dicionario.transmissao = envolvido.fracao < proprietarios[id] ? 'PARCIAL' : 'TOTAL';
      }

      if(envolvido.papel == 'DEVEDOR' && envolvido.fracao > 0 && proprietarios[id]){
        dicionario.garantia = envolvido.fracao < proprietarios[id] ? 'PARCIAL' : 'TOTAL';
      }

      // if (dicionario.tipoPessoa == 'JURIDICA') {
      //   dicionario.cnpj = dicionario.documento;
      // }
      //
      // if (dicionario.tipoPessoa == 'FISICA') {
      //   dicionario.cpf = dicionario.documento;
      //
      //   dicionario.estadoCivil = FrontBusiness.getLabel(dicionario.estadoCivil, IndicadorPessoalBusiness.getEstadosCivil()).toLowerCase()
      //     .replace('o(a)', dicionario.sexo == 'FEMININO' ? 'a' : 'o');
      //
      //   dicionario.regimeCasamento = FrontBusiness.getLabel(dicionario.regimeCasamento, IndicadorPessoalBusiness.getRegimes()).toLowerCase();
      //
      // }
      //
      // dicionario.sexo = FrontBusiness.getLabel(dicionario.sexo, IndicadorPessoalBusiness.getSexos()).toLowerCase();
      // dicionario.tipoPessoa = FrontBusiness.getLabel(dicionario.tipoPessoa, IndicadorPessoalBusiness.getTiposPessoa()).toLowerCase();
      // dicionario.nacionalidade = FrontBusiness.getLabel(dicionario.nacionalidade, IndicadorPessoalBusiness.getNacionalidades(), 'id', dicionario.sexo).toLowerCase();
      //
      // let camposEndereco = ['cep', 'estado', 'cidade', 'bairro', 'quadra', 'lote', 'logradouro', 'numero', 'complemento', 'pais'];
      // dicionario.endereco = {};
      // dicionario.enderecoComercial = {};
      // camposEndereco.forEach(c => {
      //   dicionario.endereco[c] = dicionario?.[c];
      //   dicionario.enderecoComercial[c] = dicionario?.[`${c}Comercial`];
      // });
      //
      // dicionario.endereco.pais = FrontBusiness.getLabel(dicionario.endereco.pais, IndicadorPessoalBusiness.getNacionalidades(), 'id', 'pais');
      // dicionario.enderecoComercial.pais = FrontBusiness.getLabel(dicionario.enderecoComercial.pais, IndicadorPessoalBusiness.getNacionalidades(), 'id', 'pais');

      if(indices[id]){
        dicionario.checklist = {...indices[id]};
      }

      return dicionario;

    };

    let dicionario = await dicionarioEnvolvido(envolvido.indicadorPessoalVersao, envolvido, proprietarios, indices);

    const versao = envolvido.indicadorPessoalVersao || envolvido;

    if (versao.tipoPessoa == 'FISICA') {
      dicionario.conjuge = null;
      dicionario.convivente = null;

      if (versao.conjuge) {
        let conjuge = versao.conjuge;
        dicionario.conjuge = await dicionarioEnvolvido(conjuge, envolvido.conjuge, proprietarios, indices);
        if(versao.possuiUniaoEstavel && dicionario.estadoCivil.toLowerCase() !== 'casado' && dicionario.estadoCivil.toLowerCase() !== 'casada'){
          dicionario.convivente = dicionario.conjuge;
          dicionario.conjuge = null;
        }
      }

    }

    return dicionario;

  },

  async criarSubgrupo(lista, node, dicionario, callback, debug){

    let output = [], novaLista = [...lista];
    const bkp = {...dicionario.checklist };
    const grupoBkp = {...dicionario.grupo };

    if(node.params.agrupar !== undefined){
      let indices = node.params.agrupar.split(/\s*\|\s*/);
      novaLista = FrontBusiness.agruparArray(novaLista, indices, proxy);
    }

    if(debug){
      debug.agrupamento = [...novaLista];
    }

    let listar = node.params.lista;

    if(listar != null){
      dicionario[listar] = novaLista;
      return await callback(node.children, dicionario, debug);
    }

    for(let i in novaLista){
      dicionario.grupo = {...novaLista[i]};
      dicionario.checklist = {...bkp, ...dicionario.grupo, valores : undefined};
      output.push(await callback(node.children, dicionario, debug));

      dicionario.grupo = {...grupoBkp};
      dicionario.checklist = {...bkp};
    }

    return '  ' + FrontBusiness.formatArray(output, node.params.separador, node.params.ultimo)  + ' ';
  },

  /**
   * Tag <documentos-protocolo>: repete o conteúdo para cada documento do protocolo e publica a
   * chave `documento` dentro do bloco, com os campos padrão da espécie.
   *
   * Gêmea de `minuta/copiladores/IParserDocumentos.java`. A minuta do ato é gerada aqui no
   * navegador, e a de exigência, certidão e recibo é gerada no backend — quem escreve o modelo não
   * escolhe por qual dos dois o texto passa, então os filtros e as variáveis publicadas têm que ser
   * os mesmos. Os campos vêm de `ProtocoloDocumentoVariaveis` pela listagem de documentos do
   * protocolo; ver `gerarDicionario`.
   *
   * Filtros, combinados por E:
   * - `indice`: os documentos respondidos num requisito de checklist. Requisito sem resposta não
   *   seleciona documento nenhum.
   * - `especie`: a constante de EnumEspecieDocumento (ESCRITURA_PUBLICA), não o rótulo.
   * - `tipo`: id ou nome do tipo de documento cadastrado pelo cartório.
   *
   * Não confundir com a tag <documentos>, que continua publicando a lista e não abre escopo.
   */
  async documentosProtocolo(node, dicionario, callback, debug){

    let lista = Object.values(dicionario.documentos || {});

    if(node.params.indice !== undefined){
      const resposta = dicionario.checklist?.[node.params.indice];
      const ids = (Array.isArray(resposta) ? resposta : [resposta]).filter(e => e);
      lista = ids.map(i => dicionario.documentos?.[i]).filter(e => e);
    }

    if(node.params.especie !== undefined){
      const alvo = String(node.params.especie).trim().toUpperCase();
      lista = lista.filter(documento => String(documento.especieId || '').toUpperCase() === alvo);
    }

    if(node.params.tipo !== undefined){
      const alvo = String(node.params.tipo).trim().toUpperCase();
      lista = lista.filter(documento => String(documento.tipoDocumentoId || '').toUpperCase() === alvo
        || String(documento.tipoDocumento || '').toUpperCase() === alvo);
    }

    if(debug){
      debug.lista = lista;
    }

    const saida = [];
    for(const documento of lista){
      saida.push(await callback(node.children, {...dicionario, documento}, debug));
    }

    return FrontBusiness.formatArray(saida, node.params.separador, node.params.ultimo);

  },

  async repetidorChecklist(node, dicionario, callback, debug){
    const val = dicionario.checklist[node.params.indice];
    let lista = (Array.isArray(val) ? val : [val]).filter(e => e);

    if(node.params.documento !== undefined){
      lista = lista.map(i => dicionario.documentos[i]).filter(e => e);
    }

    console.error("Método ultrapassado. Favor usar o repetidor.");

    return this.criarSubgrupo(lista, node, dicionario, callback, debug);
  },

  async agruparChecklist(dicionario, node, callback, debug){
    const lista = (Utils.clone(dicionario.grupo) || {}).valores || [];

    console.error("Método ultrapassado. Favor usar o repetidor.");

    return this.criarSubgrupo(lista, node, dicionario, callback, debug);
  },

  plural(node, dicionario, envolvidos, ato, debug){

    let genero = 'masculino', quantidade = 0, saidaPlural = '';

    if(node.params.grupo != undefined){

      let group = dicionario.checklist[node.params.grupo] || [];
      if(debug) {
        debug.group = group;
      }
      quantidade = group.length;

    }else{

      let filtrados = envolvidos.filter(e => !node.params.papel || e.papel.toLowerCase() == node.params.papel.toLowerCase());
      quantidade = filtrados.length;

      if(quantidade == filtrados.filter(e => (e.indicadorPessoalVersao.sexo || '').toUpperCase() == 'FEMININO').length){
        genero = 'feminino';
      }

    }

    if(debug) {
      debug.plural = {quantidade, genero};
    }

    if (quantidade == 1) {
      saidaPlural += genero != 'masculino' && node.params.singularFeminino ? node.params.singularFeminino : node.params.singular;
    } else {
      saidaPlural += genero != 'masculino' && node.params.pluralFeminino ? node.params.pluralFeminino : node.params.plural;
    }

    return getVar(saidaPlural, dicionario, false, true);

  },

  fracao(node, dicionario, envolvidos ){

    let valor = 0;

    let key = node.params.manual !== undefined ? 'area' : 'fracao';

    if(dicionario.envolvido){

      valor = dicionario.envolvido[key] || 0;
      let consorte = dicionario.envolvido.conjuge || dicionario.envolvido.convivente;

      if(consorte?.id && consorte?.papel == dicionario.envolvido.papel){

        if(node.params.casal !== undefined){
          valor = valor + consorte[key];
        }

        if(node.params.conjuge !== undefined || node.params.consorte !== undefined){
          valor = consorte[key];
        }

      }

    }

    if(node.params.transmitentes !== undefined){
      valor = envolvidos.reduce((total, e) => total + (e.papel == 'TRANSMITENTE' && e[key]? e[key] : 0), 0);
    }

    if(node.params.adquirentes !== undefined){
      valor = envolvidos.reduce((total, e) => total + (e.papel == 'ADQUIRENTE' && e[key]? e[key] : 0), 0);
    }

    if(node.params.devedores !== undefined){
      valor = envolvidos.reduce((total, e) => total + (e.papel == 'DEVEDOR' && e[key]? e[key] : 0), 0);
    }

    if(node.params.credores !== undefined){
      valor = envolvidos.reduce((total, e) => total + (e.papel == 'CREDOR' && e[key]? e[key] : 0), 0);
    }

    if(node.params.promitenteAdquirente !== undefined){
      valor = envolvidos.reduce((total, e) => total + (e.papel == 'PROMITENTE_COMPRADOR' && e[key]? e[key] : 0), 0);
    }

    if(node.params.promitenteTransmitente !== undefined){
      valor = envolvidos.reduce((total, e) => total + (e.papel == 'PROMITENTE_VENDEDOR' && e[key]? e[key] : 0), 0);
    }

    let maxDecimal = (node.params.maximo !== undefined ? node.params.maximo : node.params.decimal) || 20;

    if(node.params.area !== undefined && key == 'fracao'){
      valor = valor / 100 * (dicionario.imovel.area || 1);
      valor = Utils.truncateNumber(valor, maxDecimal);
    }

    if(node.params.texto !== undefined){
      return FrontBusiness.toFraction(valor);
    }

    valor = node.params.arredondar !== undefined ? valor : Utils.truncateNumber(valor, maxDecimal || 20);

    if(node.params.extenso !== undefined){
      let valorStr = `${valor}`;
      if(valorStr.includes('.') && valorStr.split('.')[1].length == 1){
        valorStr = `${valor}0`;
      }

      if(node.params.area !== undefined){

        let metragem = IndicadorRealBusiness.getMedidas().find(e => e.id == dicionario.imovel.medidaArea);

        return extenso(valorStr.replace('.', ','), { mode: 'currency' })
          .replace('real', metragem?.singular || "metros")
          .replace('reais', metragem?.plural || "metros")
          .replace('centavos', metragem?.decimal || "decímetros") + (dicionario.imovel.medidaArea == 'M2' ? " quadrados" : "");
      }

      if (node.params.percentual !== undefined) {
        return extenso(valorStr.replace('.', ','), { mode: 'percentual' });
      }

      return extenso(valorStr.replace('.', ',')) + " por cento"; //, { mode: 'currency' }//

      // let inteiroStr = texto.includes('centavos') ? 'inteiro' : '';
      // let inteirosStr = texto.includes('centavos') ? 'inteiros' : '';
      //
      // const len = valorStr.split('.')?.[1]?.length;
      // let centavos = stringPercentual?.[len];
      //
      // return texto.replace('real', inteiroStr)
      //               .replace('reais', inteirosStr)
      //               .replace('centavos', centavos) + " por cento";
    }

    return parseFloat(valor).toLocaleString("pt-BR", {
        minimumFractionDigits: parseInt(node.params.decimal !== undefined ? node.params.decimal : 0, 10),
        maximumFractionDigits: parseInt(maxDecimal !== undefined ? maxDecimal : 2, 10),
        style: 'currency',
        currency: 'BRL'
      }).replace("R$ ", "") +
      (node.params.area !== undefined ? (dicionario.imovel.medidaArea || '').toLowerCase().replaceAll('2', '²') : '%');

  },

}
